import React from "react";
import { Button, Modal, Toast, Badge, Icon } from "antd-mobile";
import { post } from "../../utils/request";
import { href } from "../../utils/util";
import successUrl from "./images/quan.png";
import failUrl from "./images/fail.png";
import "./index.less";
import { wxfx } from "../../utils/wxfx.js";

class yysChargingOperatorDownload extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
            isSuccess: false,
        };
    }

    // #/inviteNewUsers?app_stoken=xxxx&
    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }
            const isSuccess = ops.status == "success";
            document.title = isSuccess ? "邀请成功" : "邀请失败";
            this.setState(
                {
                    urlOps: ops,
                    isSuccess,
                },
                () => {
                    this.fx();
                }
            );
        }
    }

    fx() {
        const { urlOps } = this.state;
        wxfx({
            title: "注册远程慧联app充电",
            imgUrl: "https://static.hellogil.com/oss-prod-unsafe-group/statics/6a8009d8063148ccb0ec9b39b02f41b3.png",
            desc: `享受遍布全国超50万充电桩服务`,
            url: `https://www.hellogil.com/payment/#/inviteNewUsersShare?name=${urlOps.name}&inviteCode=${urlOps.inviteCode}`, //`${window.location.origin}${window.location.pathname}#/inviteNewUsersShare?name=${urlOps.name}&inviteCode=${urlOps.inviteCode}`
        });
    }

    render() {
        const {
            modalType,
            isSuccess,
            urlOps: { reason },
        } = this.state;
        const imgUrl = isSuccess ? successUrl : failUrl;
        const title = isSuccess ? "邀请成功" : "邀请失败";
        return (
            <div className="yysChargingOperatorDownloadBox">
                <img src={imgUrl} />
                <div>
                    <h2>{title}</h2>
                    {isSuccess ? (
                        <p style={{ marginTop: "0.4rem" }}>
                            当您绑定充电伙伴后，您的充电金额将通过伙伴进行充值，并使用伙伴卡进行充电，享受伙伴卡专属优惠。对应充电订单属于慧联非自营充电订单，不支持慧联开票，请联系伙伴进行开票。
                        </p>
                    ) : (
                        <p style={{ marginTop: "0.16rem" }}>
                            {decodeURIComponent(reason)}
                        </p>
                    )}
                </div>
                {/* //微信跳转按钮 */}
                <wx-open-launch-weapp
                    id="launch-btn"
                    appid="wx58df896c4ab48352"
                    // username="gh_66734d3442dd" //username 是要跳往的小程序的原始id gh开头的
                    path="hcdPages/home/index" //{`${targetUrl}.html`} //跳转到小程序的路径 一定要在后面加.html 这是一个坑
                    style={{
                        display: "inline-block",
                        backgroundColor: "#009F90",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: "bold",
                        textAlign: "center",
                        width: "100%",
                        height: "0.44rem",
                        lineHeight: "0.44rem",
                        borderRadius: "0.04rem",
                        marginBottom: "0.16rem",
                    }}
                >
                    前往慧充电小程序
                    <script type="text/wxtag-template">
                        {/* //微信官方文档上是template标签这个 默认是display none的 如果你之前用这个标签没显示button 很正常 react 不支持这个template标签 我们得用script 这是一个坑  */}
                        <div
                            style={{
                                display: "inline-block",
                                color: "#fff",
                                fontSize: "18px",
                                fontWeight: "bold",
                                textAlign: "center",
                                width: "100%",
                                marginTop: "11px",
                            }}
                        >
                            跳转慧充电小程序
                        </div>
                    </script>
                </wx-open-launch-weapp>

                <a
                    className="reward_3_row"
                    onClick={() => {
                        window.location.href =
                            "https://www.hellogil.com/appDownload/#/HuilianDownload";
                    }}
                >
                    下载远程慧联APP
                </a>
            </div>
        );
    }
}

export default yysChargingOperatorDownload;



// WEBPACK FOOTER //
// ./src/yysChargingOperator/download/index.js